export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pink%20magenta%20gradient%20background%20with%20soft%20flowing%20lines%20and%20modern%20minimalist%20design%2C%20clean%20white%20negative%20space%2C%20smooth%20curves%2C%20contemporary%20corporate%20aesthetic%2C%20subtle%20texture%2C%20artistic%20composition%20with%20warm%20undertones%2C%20no%20text%2C%20no%20people%2C%20abstract%20fluid%20shapes&width=1920&height=1080&seq=az-hero-bg&orientation=landscape"
          alt="A&Z Schoonmaakdienst achtergrond"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-8">
          <span className="w-2 h-2 rounded-full bg-primary-400"></span>
          <span className="text-xs md:text-sm font-medium text-background-50/90">Landelijk actief in heel Nederland</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          Schoonmaak
          <br />
          <span className="text-primary-300">zonder compromissen</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          A&Z Schoonmaakdienst levert professionele schoonmaak voor kantoren, bedrijfspanden, winkels, horeca en zorginstellingen. 
          Wij zorgen voor een frisse en hygiënische werkomgeving — zodat u zich op de rest kunt richten.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold whitespace-nowrap hover:bg-primary-400 transition-all duration-200 cursor-pointer"
          >
            Offerte aanvragen
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="#diensten"
            onClick={(e) => { e.preventDefault(); scrollTo('diensten'); }}
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/10 text-background-50 text-base font-medium whitespace-nowrap border border-background-50/25 hover:bg-background-50/20 transition-all duration-200 cursor-pointer"
          >
            Onze diensten
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#diensten"
          onClick={(e) => { e.preventDefault(); scrollTo('diensten'); }}
          className="flex flex-col items-center gap-2 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer"
        >
          <span className="text-xs font-medium">Ontdek meer</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}